import React from 'react';
export function Footer() {
  return <footer className="bg-ink px-4 pb-28 pt-12 sm:px-6" data-id="element-126" data-mp="32wd2qgad7ltj">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-127" data-mp="3gfsjo3v2keir">
        <p className="font-display text-lg font-extrabold uppercase tracking-[0.24em] text-lime" data-id="element-128" data-mp="3gh3qkcjta2e3">
          Dre Karito
        </p>
        <p className="mt-5 text-[13px] leading-relaxed text-slate-500" data-id="element-129" data-mp="36oxyl2tk7kyw">
          Route Maladie Rénale™ — Matériel éducatif destiné aux professionnels de santé. Il ne
          remplace pas le jugement clinique individuel, les recommandations locales applicables ni
          la relation entre le professionnel de santé et le patient.
        </p>
        <p className="mt-4 text-[12px] text-slate-600" data-id="element-130" data-mp="3le2icog05x94">
          © 2026 Dre Karito. Tous droits réservés.
        </p>
      </div>
    </footer>;
}